import { Component, HostListener, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
//import { ClientDataOnboarding } from '@tech-models/client-data-onboarding.model';
import { ClientDataOnboarding } from '@techrules/portallib';

import { CommonService } from '@tech-services/common.service';
import { OnboardingcoreService } from '@tech-services/onboardingcore.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-smsverification',
  templateUrl: './smsverification.component.html',
  styleUrls: ['./smsverification.component.scss'],
})
export class SmsverificationComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  public form: UntypedFormGroup;
  public phoneExist: boolean = false;
  public codephoneExist: boolean = false;
  public codePhone: string = '';
  private captchatoken: string;

  constructor(
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private onboardingCoreService: OnboardingcoreService,
    private dialog: MatDialog,
    private commonService: CommonService,
    private router: Router
  ) {
    this.newform();
  }

  @HostListener('window:beforeunload', ['$event'])
  //Guardamos la estructura de la simulacion en unlocalstorage para no perderla al actualizar el navegador (F5)
  loadNotification($event: any) {
    localStorage.setItem(
      'OnboardingClient',
      JSON.stringify(this.onboardingCoreService.client)
    );
  }

  ngOnInit() {
    //Revisamos la estructura de simulacion y si no esta la recogemos del Localstorage para no perderlo si se ha hecho F5
    if (Object.entries(this.onboardingCoreService.client).length == 0) {
      this.onboardingCoreService.client = JSON.parse(
        localStorage.getItem('OnboardingClient')
      );
      localStorage.removeItem('OnboardingClient'); //Eliminamos le local para no dejar residuos
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (AppConfig.settings.defaultCodeCountryPhone != '') {
        this.codePhone = AppConfig.settings.defaultCodeCountryPhone;
        this.form.controls['codephone'].setValue(
          AppConfig.settings.defaultCodeCountryPhone
        );
      } else {
        this.loadCountrySelect();
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public newform() {
    this.form = this.fb.group({
      codephone: ['', [Validators.required]],
      phone: ['', [Validators.required]],
    });
  }

  public goNext(event) {
    this.beforeSubmittingForm();
  }

  private beforeSubmittingForm(): void {
    this.recaptchaV3Service.execute('registerSubmit').subscribe(
      (token) => {
        this.captchatoken = token;
        this.submitForm();
      },
      (error) => {
        console.log(error);
        console.log('Error trying to verify request (reCaptcha v3)');
      }
    );
  }

  private submitForm(): void {
    this.commonService.loading$.emit(true);
    this.onboardingCoreService.client.Phone =
      this.form.value.codephone + this.form.value.phone;
    this.onboardingCoreService.client.Language =
      localStorage.getItem('Language');

    this.onboardingCoreService
      .createAccount(this.onboardingCoreService.client, this.captchatoken)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.commonService.loading$.emit(false);
        this.onboardingCoreService.smsVerificationId = data.VerificationId;
        this.onboardingCoreService.showSmsCode = true;
        this.onboardingCoreService.showSignup = false;
        this.onboardingCoreService.showSmsVerification = false;
        this.router.navigate(['/signup/smsaddcode']);
      });
  }

  public keyupphone() {
    this.phoneExist = false;
  }

  public keyupcodephone(event) {
    if (!event.target.value.includes('+')) {
      event.target.value = '+' + event.target.value;
    }
    this.codephoneExist = false;
  }

  public loadCountrySelect() {}

  public onBeforeUnload() {
    console.log(this.onboardingCoreService.client);
  }
}
